import Vue from 'vue';
import fetch from '../../../services/fetch';

const state = {
  collectiveAgreements: {
    status: '',
    agreements: []
  }
};

const getters = {
  collectiveAgreements: (state) => state.collectiveAgreements,
};

const actions = {
  async getCollectiveAgreements ({ commit, dispatch }) {
    commit('setCollectiveAgreementsStatus', 'loading')

    const agreements = await fetch.get('/collective-agreements').then(res=>res.data)

    commit('setCollectiveAgreements', {
      status: 'loaded',
      agreements: agreements,
    })
  },
};

const mutations = {
  setCollectiveAgreementsStatus: (state,status) => Vue.set(state.collectiveAgreements, 'status', status),
  setCollectiveAgreements: (state,collectiveAgreements) => Vue.set(state, 'collectiveAgreements', collectiveAgreements),
};

export default {
  state,
  getters,
  actions,
  mutations
}